export const module11InitialState = {
  module11: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    coins: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      SurfBoardRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SurfBoardBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CoralBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CoralRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FloatationInnerTube: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FloatationBall: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SeashellsRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SeashellsGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      MermaidRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      MermaidBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      ClamBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      ClamPink: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SeaweedBrown: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SeaweedGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CrabwearGlasses: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      CrabWearMustash: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      SandCastle: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Treasure: {
        unlocked: false,
        x: 0,
        y: 0,
      },
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module11Reducer = (state = module11InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE11_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        SurfBoardRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SurfBoardBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CoralBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CoralRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FloatationInnerTube: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FloatationBall: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SeashellsRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SeashellsGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        MermaidRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        MermaidBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        ClamBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        ClamPink: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SeaweedBrown: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SeaweedGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CrabwearGlasses: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        CrabWearMustash: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        SandCastle: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Treasure: {
          unlocked: false,
          x: 0,
          y: 0,
        },
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]].unlocked = true;
              tempRewards[Object.keys(tempRewards)[j]].x = obj[i]?.x_multiplier;
              tempRewards[Object.keys(tempRewards)[j]].y = obj[i]?.y_multiplier;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"SurfBoardRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"FloatationInnerTube\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SeashellsRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CrabWearMustash\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module11: {
          ...state.module11,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module11InitialState,
      };
    }
    case 'MODULE11_SET_DAY': {
      return {
        ...state,
        module11: {
          ...state.module11,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE11_SET_GameDetials': {
      return {
        ...state,
        module11: {
          ...state.module11,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE11_SET_stepCompleted': {
      return {
        ...state,
        module11: {
          ...state.module11,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE11_SET_dayCompleted': {
      return {
        ...state,
        module11: {
          ...state.module11,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE11_SET_CAMERAOPEN': {
      return {
        ...state,
        module11: {
          ...state.module11,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE11_SET_KEY': {
      return {
        ...state,
        module11: {
          ...state.module11,
          keys: action.payload,
        },
      };
    }
    case 'MODULE11_SET_COIN': {
      return {
        ...state,
        module11: {
          ...state.module11,
          coins: action.payload,
        },
      };
    }
    case 'MODULE11_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module11: {
          ...state.module11,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE11_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module11: {
          ...state.module11,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE11_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module11: {
          ...state.module11,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE11_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module11: {
          ...state.module11,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE11_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module11: {
          ...state.module11,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE11_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module11: {
          ...state.module11,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE11_SET_REWARD11': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SurfBoardRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD11_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SurfBoardRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD12': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SurfBoardBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD12_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SurfBoardBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD21': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            CoralBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD21_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            CoralBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD22': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            CoralRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD22_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            CoralRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD31': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            FloatationInnerTube: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD31_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            FloatationInnerTube: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD32': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            FloatationBall: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD32_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            FloatationBall: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD41': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SeashellsRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD41_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SeashellsRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD42': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SeashellsGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD42_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SeashellsGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD51': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            MermaidRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD51_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            MermaidRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD52': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            MermaidBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD52_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            MermaidBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD61': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            ClamBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD61_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            ClamBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD62': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            ClamPink: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD62_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            ClamPink: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD71': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SeaweedBrown: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD71_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SeaweedBrown: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD72': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SeaweedGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD72_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SeaweedGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD81': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            CrabwearGlasses: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD81_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            CrabwearGlasses: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD82': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            CrabWearMustash: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_REWARD82_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            CrabWearMustash: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_PRIZE1': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SandCastle: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_PRIZE1_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            SandCastle: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_PRIZE2': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            Treasure: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_PRIZE2_POSITION': {
      return {
        ...state,
        module11: {
          ...state.module11,
          rewards: {
            ...state.module11.rewards,
            Treasure: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE11_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module11: {
          ...state.module11,
          unlockedDays: {
            ...state.module11.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE11_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module11: {
          ...state.module11,
          unlockedDays: {
            ...state.module11.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE11_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module11: {
          ...state.module11,
          unlockedDays: {
            ...state.module11.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE11_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module11: {
          ...state.module11,
          unlockedDays: {
            ...state.module11.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE11_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module11: {
          ...state.module11,
          unlockedDays: {
            ...state.module11.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE11_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module11: {
          ...state.module11,
          unlockedDays: {
            ...state.module11.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE11_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module11: {
          ...state.module11,
          unlockedDays: {
            ...state.module11.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE11_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module11: {
          ...state.module11,
          unlockedDays: {
            ...state.module11.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module11Reducer;
